import { render, staticRenderFns } from "./ListReceipts.vue?vue&type=template&id=4fd95e20"
import script from "./ListReceipts.vue?vue&type=script&lang=js"
export * from "./ListReceipts.vue?vue&type=script&lang=js"
import style0 from "./ListReceipts.vue?vue&type=style&index=0&id=4fd95e20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports